import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  assignUsergroupToUserApi,
  assignUserToGroupApi,
  createMenuApi,
  createUserGroupApi,
  getAllMenuListApi,
  getAllUserGroupsApi,
  getAssignedGroupToUserApi,
  getAssignedUsersToGroupApi,
  getSingleUserGroupDetailsApi,
  updateMenuApi,
  updateUserGroupApi
} from '../../apis/userManagementApis';
import {
  assignGroupToUserType,
  CreateMenuPayloadType,
  CreateUserGroupType,
  GetAllUserGroupPayloadType,
  GetAllUsersToGroupDetailsPayloadType,
  getAssignedGroupToUserPayloadType,
  GetSingleUserGroupDetailsType,
  UpdateUserGroupType
} from '../../commonTypes/userManagementTypes';

export const getAllMenuListAction = createAsyncThunk(
  'userManagement/getallMenuList',
  async (token: string) => {
    const response = await getAllMenuListApi(token);
    return response.data;
  }
);

export const createUserGroupAction = createAsyncThunk(
  'userManagement/createUserGroup',
  async (data: CreateUserGroupType) => {
    const response = await createUserGroupApi(data);
    return response.data;
  }
);

export const updateUserGroupAction = createAsyncThunk(
  'userManagement/updateUserGroup',
  async (data: UpdateUserGroupType) => {
    const response = await updateUserGroupApi(data);
    return response.data;
  }
);

export const getAllUserGroupsAction = createAsyncThunk(
  'userManagement/getAllUserGroups',
  async (data:GetAllUserGroupPayloadType) => {
    const response = await getAllUserGroupsApi(data);
    return response.data;
  }
);

export const getSingleUserGroupDetailsAction = createAsyncThunk(
  'userManagement/getSingleUserGroupDetails',
  async (data: GetSingleUserGroupDetailsType) => {
    const response = await getSingleUserGroupDetailsApi(data);
    return response.data;
  }
);

export const assignGroupToUserAction = createAsyncThunk(
  'userManagement/assignGroupToUser',
  async (data: assignGroupToUserType) => {
    const response = await assignUsergroupToUserApi(data);
    return response.data;
  }
);

export const getAssignedGroupToUserAction = createAsyncThunk(
  'userManagement/getAssignedGroupToUser',
  async (data:getAssignedGroupToUserPayloadType) => {
    const response = await getAssignedGroupToUserApi(data);
    return response.data;
  }
);

export const createUserAction = createAsyncThunk(
  'userManagement/createUser',
  async (data: CreateMenuPayloadType) => {
    const response = await createMenuApi(data);
    return response.data;
  }
);



export const updateMenuListAction = createAsyncThunk(
  'userManagement/updateUser',
  async (data: CreateMenuPayloadType) => {
    const response = await updateMenuApi(data);
    return response.data;
  }
);
//new  get Assigned users to group
export const getAssignedUsersToGroupAction= createAsyncThunk(
  'userManagement/getAssignedUsersToGroup',
  async (data:GetAllUsersToGroupDetailsPayloadType)=>{
    const response = await getAssignedUsersToGroupApi(data);
    return response.data;
  }

)

export const assignUsersToGroupAction = createAsyncThunk(
  'userManagement/assignUsersToGroup',
  async (data:assignGroupToUserType)=>{
    const response = await assignUserToGroupApi(data);
    return response.data;
  }

)

